import React, { useState } from "react";
import { Button, FormControl } from "@mui/material";
import { Box, Flex, Input } from "@100mslive/roomkit-react";
import { Cross } from "../../../icons";
import { ToastManager } from "../../Toast/ToastManager";
import { CONVERT_UPPERCASE } from "../../../common/utils";

const PostTagCreateModal = props => {
  const { onClose, onUpdate } = props;

  const [name, setName] = useState("");

  const onSave = async () => {
    let n = name?.trim();
    if (!n) {
      return ToastManager.addToast({ title: "Please enter tag" });
    }
    onUpdate(CONVERT_UPPERCASE(n));
  };

  return (
    <Flex
      align="center"
      direction="column"
      className="eventsPopup eventsPopup-sm"
      onClick={() => {
        onClose(false);
      }}
    >
      <Box
        className="eventsPopup-inner"
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div
          className="eventsPopup-close"
          onClick={() => {
            onClose(false);
          }}
        >
          <Cross />
        </div>
        <div className="eventsPopup-header">
          <div className="eventsPopup-header-heading">Create New Tag</div>
        </div>
        <div className="eventsPopup-content">
          <Flex direction="column" css={{ gap: "20px" }}>
            <FormControl className="custom-form-group">
              <label htmlFor="tag-name" className="custom-form-label big-label">
                Title
              </label>
              <Input
                id="tag-name"
                name="module"
                placeholder="Enter tag"
                className="custom-form-input"
                value={name}
                maxLength={30}
                onChange={e =>
                  setName(
                    e.target?.value?.replace(/[^a-zA-Z0-9 ]/g, "")?.slice(0, 30)
                  )
                }
              />
            </FormControl>
          </Flex>

          <div className="events-page-account-setting-content-box-line"></div>
          <Flex align="center" justify="center">
            <Button
              color="primary"
              variant="outlined"
              className="events6ix-btn events6ix-btn-primary"
              type="button"
              onClick={onSave}
            >
              Save
            </Button>
          </Flex>
        </div>
      </Box>
    </Flex>
  );
};

export default PostTagCreateModal;
